import { CloudXIntegrationDataSchema } from "@redotech/redo-model/integrations/returns/cloudx/types";
import type { infer as zInfer } from "zod/v4";
import { object } from "zod/v4";

export const getCloudXIntegration = {
  name: "getCloudXIntegration" as const,
  input: object({}),
  output: CloudXIntegrationDataSchema.nullable(),
};

export type CloudXIntegration = zInfer<typeof getCloudXIntegration.output>;
